import { Addressable } from './api-common.js';
import { BASE_API_URL } from '../envs.js';
import { replaceAll } from '../helpers/string.js';
import { getLanguageCode } from '../i18n.js';
export class Bicycle extends Addressable {
    constructor(data) {
        super(data);
        if (typeof data.get === 'function') {
            data = data;
            this.id = Number(data.getId());
            this.refid = Number(data.get('id'));
            this.title = data.get('title');
            this.abstract = data.get('abstract');
            this.abstractReturn = data.get('abstract_return');
            this.organisation = data.get('organisation');
            this.type =
                data.get('category') === 'rental' ? 'velorental' : 'cycleservice';
        }
        else {
            Object.assign(this, data);
        }
    }
}
export class Accommodation extends Addressable {
    constructor(data) {
        super(data);
        if (typeof data.get === 'function') {
            data = data;
            this.id = Number(data.getId());
            this.title = data.get('name');
            this.types = data.get('types');
            this.photo = data.get('foto');
            this.starsPara = Number(data.get('stars_parahotellerie'));
            this.starsHotel = Number(data.get('stars_hotellerie'));
            this.beds = data.get('beds');
            this.campingPlaces = data.get('campingplaces');
            this.priceFrom = data.get('pricefrom');
            this.priceTo = data.get('priceto');
            this.hotelGroup = data.get('hotelgroup');
        }
        else {
            Object.assign(this, data);
        }
    }
}
export class Bookable extends Addressable {
    constructor(data) {
        super(data);
        Object.assign(this, data);
        if (this.urlBooking?.length)
            this.urlBookingLink = this.urlBooking;
    }
}
export class Swisspark {
    constructor(data) {
        if (typeof data.get === 'function') {
            data = data;
            this.id = Number(data.getId());
            this.refid = Number(data.get('id'));
            this.title = data.get('title');
            this.abstract = data.get('abstract');
            this.photo = data.get('foto');
            this.url = data.get('url');
        }
        else {
            Object.assign(this, data);
        }
    }
}
export class WildlifeArea {
    constructor(data) {
        const languageCode = getLanguageCode();
        const languageKey = languageCode === 'en' ? 'de' : languageCode;
        this.id = data.get('id');
        this.title = data.get('label');
        this.dispositions = data.get(`best_${languageKey}`);
        this.protectionState = data.get(`schutzs_${languageKey}`);
        this.protectionPeriod = data.get('schutzzeit');
        this.moreInfo = data.get('zusatzinformation');
        this.subtitle = data.get('subtitle');
    }
}
export class WildlifeRoute {
    constructor(data) {
        const languageCode = getLanguageCode();
        const languageKey = languageCode === 'en' ? 'de' : languageCode;
        this.type = data.get(`wegtyp_${languageKey}`);
        this.title = data.get('label');
        this.limitations = data.get('einschraenkungen');
        this.subtitle = data.get('subtitle');
        this.id = data.get('id');
    }
}
class AlpguardDogOrCantonOrMuni {
    constructor(data) {
        this.title = data.get('label');
        this.htmlPopup = data.get('htmlPopup');
        this.id = data.get('id');
    }
}
export class AlpguardDog extends AlpguardDogOrCantonOrMuni {
}
export class Station {
    constructor(data) {
        if (typeof data.get === 'function') {
            data = data;
            this.id = Number(data.getId());
            this.refid = Number(data.get('id'));
            this.title = data.get('title');
            this.subtitle = data.get('sc_transport');
        }
        else {
            Object.assign(this, data);
        }
    }
}
export class Slowup {
    constructor(data) {
        if (typeof data.get === 'function') {
            data = data;
            this.id = Number(data.getId());
            this.refid = Number(data.get('id'));
            this.title = data.get('title');
            this.date = data.get('date');
            this.photo = data.get('foto');
            this.photoAbstract = data.get('abstract');
            this.urlLink = data.get('url1_link');
            this.urlText = data.get('url1_text');
        }
        else {
            Object.assign(this, data);
        }
        if (this.date)
            this.date = replaceAll(new Date(this.date).toLocaleDateString('en-GB'), '/', '.');
    }
}
export class Shooting {
    constructor(data) {
        const lang = getLanguageCode();
        this.id = data.get('id');
        this.title = data.get('label') || data.get('name');
        this.name = data.get('name');
        this.contact = data.get('contact');
        this.phone = data.get('phone');
        this.email = data.get('email');
        this.nameLocation = data.get('name_location');
        this.url = data.get(`url_${lang}`);
        const scheduleJson = data.get('schedule');
        if (scheduleJson) {
            try {
                this.schedule = JSON.parse(scheduleJson);
            }
            catch {
                this.schedule = [];
            }
        }
        else {
            this.schedule = [];
        }
    }
}
export class Municipality extends AlpguardDogOrCantonOrMuni {
}
export class Canton extends AlpguardDogOrCantonOrMuni {
}
export async function fetchAdditionalLayer(ids, type, lang) {
    if (type === 'station' || type === 'slowup') {
        return fetchAdditionalLayerByRefid(ids, type, lang);
    }
    const response = await fetch(`${BASE_API_URL}/api/4/feature/${type}/${ids.join(',')}?lang=${lang}`);
    return (await response.json()).map((poi) => {
        if (type === 'accommodation')
            return new Accommodation(poi);
        if (type === 'bookable')
            return new Bookable(poi);
        if (type === 'swisspark')
            return new Swisspark(poi);
        else
            return new Bicycle({ ...poi, type });
    });
}
export async function fetchAdditionalLayerByRefid(refids, type, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/feature/${type}/refid/${refids.join(',')}?lang=${lang}`);
    return (await response.json()).map((poi) => {
        if (type === 'station')
            return new Station(poi);
        if (type === 'swisspark')
            return new Swisspark(poi);
        if (type === 'slowup')
            return new Slowup(poi);
        if (type === 'cycleservice' || type === 'velorental')
            return new Bicycle({ ...poi, type });
        if (type === 'accommodation')
            return new Accommodation(poi);
        return undefined;
    });
}
export async function postAddImage(formData, errorMsg) {
    try {
        const response = await fetch(`${BASE_API_URL}/api/6/pois/addimage`, {
            credentials: 'include',
            method: 'post',
            body: formData,
        });
        if (!response.ok) {
            throw new Error(errorMsg);
        }
        return (await response.json()).filename;
    }
    catch {
        throw new Error(errorMsg);
    }
}
//# sourceMappingURL=api-poi.js.map